import * as React from "react";
import useAssetData from "./useAssetData";

export function AssetImageLink({ assetName, gatewayURL }) {
  const asset = useAssetData(assetName);
  if (!asset?.ipfs_hash) return <span className="dim">—</span>;
  return (
    <a href={gatewayURL + asset.ipfs_hash} target="_blank" rel="noreferrer">
      <img
        className="asset-thumb"
        src={"/thumbnail?assetName=" + encodeURIComponent(assetName)}
        alt=""
      />
    </a>
  );
}
